<template>
    <div class="element product-tile">
        <div class="hidden" aria-hidden="true">
            <div class="product-data" :data-handle="product.handle" :data-product="JSON.stringify(product)" :data-default-variant="JSON.stringify(product.selected_or_first_available_variant)"></div>
        </div>
        <div class="element-callout" v-if="!product.available">
            <span class="h4 reset-letterspace lowercase">Sold Out</span>
        </div>
        <div class="element-media">
            <div class="in-bundle" v-if="inBundle">
                <p>Added to Bundle</p>
            </div>
            <template v-else>
                <a v-if="product.available" href="#" class="bundle-btn btn btn-outline btn-bg-white btn-small" @click.prevent="addToBundle(product)">Add to Bundle</a>
                <a v-else href="javascript:void(0)" class="bundle-btn btn btn-outline btn-bg-white btn-small">Sold Out</a>
                <a v-if="product.available" href="javascript:void(0)" class="quick-view-bundle-btn btn btn-outline btn-bg-white btn-small">Quickview</a>
            </template>
            <img :src="product.featured_image" :alt="product.title" class="product-image" />
        </div>

        <div class="element-content-wrapper">
            <div class="meta-wrapper">
                <div class="product-info">
                    <a href="#" @click.prevent="addToBundle(product)" class="h4 reset-letterspace lowercase product-title">{{ product.title }}</a>
                    <p class="product-price">${{ (product.price / 100).toFixed(2) }}</p>
                    <div class="product-type-link text-muted reset-letterspace">
                        {{ product.type }}
                    </div>
                </div>
                <div class="product-actions">
                    <p class="product-price">${{ (product.price / 100).toFixed(2) }}</p>
                    <a v-if="product.available && !inBundle" href="#" @click.prevent="addToBundle(product)" class="shop-link">Add to Bundle</a>
                    <template v-else>
                        <span v-if="!product.available">Sold Out</span>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["product", "inBundle"],
    methods: {
        addToBundle(p) {
            if (!this.inBundle) {
                this.$emit('add-product', p)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../scss/_variables";

img.product-image {
    width: 100%;
}

.element {
    margin-left: 15px;
    margin-right: 15px;

    @media screen and (max-width: $screen-grid-break) {
        margin: 0 !important;

        &:nth-of-type(odd) {
            padding-right: 7.5px !important;
        }
        &:nth-of-type(even) {
            padding-left: 7.5px !important;
        }
    }
}

.element-media {
    position: relative;
    margin-bottom: 29px;

}

.meta-wrapper {
    display: flex;

    .product-info {
        padding-right: 15px;

        & > a {
            margin-bottom: 7px;
        }

        @media (min-width: $screen-mobile + 1) {
            .product-price {
                display: none;
            }
        }
    }

    .product-type-link {
        margin: 3px 0;
    }

    .product-actions {
        display: flex;
        flex-direction: column;
        margin-left: auto;

        @media screen and (max-width: $screen-mobile) {
            display: none;
        }

        p {
            text-align: right;
        }

        span {
            font-size: 14px;
        }
    }
}

.in-bundle {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;

    p {
        font-size: 24px;

        @media screen and (max-width: $screen-laptop) {
            text-align: center;
        }
    }
}
</style>
